angular.module 'zc.core'

.filter "segmentValueFormat", ($parse) ->
  return (value) ->
    if angular.isString(value)
      return "\"#{value}\""
    else if _.isNull(value)
      return "null"
    else
      return value



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/filters/segment_value_format.filter.coffee